module.exports = __webpack_public_path__ + "static/media/focus-icon-1.c19bf998.png";